export const EmojiNormal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <g filter="url(#filter0_f_5246_190100)" opacity=".2">
      <path
        fill="#C9EAFF"
        d="M12.638 49.903c1.01 0 1.975-.189 2.864-.532a.872.872 0 0 1 .9.173 6.17 6.17 0 0 0 9.827-7.008.858.858 0 0 1-.07-.369l.002-.2a6.17 6.17 0 0 0-7.727-5.97.86.86 0 0 1-.763-.165 7.904 7.904 0 0 0-5.033-1.8 7.928 7.928 0 0 0-6.56 3.468.85.85 0 0 1-.432.325A6.2 6.2 0 1 0 9.7 49.545a.85.85 0 0 1 .54-.01c.757.239 1.562.368 2.397.368Z"
      />
    </g>
    <g filter="url(#filter1_f_5246_190100)">
      <path
        fill="#C9EAFF"
        d="M11.072 17.664a5.93 5.93 0 0 0 1.972-.535.92.92 0 0 1 .92.089 4.617 4.617 0 0 0 6.747-5.946.9.9 0 0 1-.105-.362 4.618 4.618 0 0 0-6.077-4.05.905.905 0 0 1-.778-.094 5.914 5.914 0 0 0-3.784-.93 5.933 5.933 0 0 0-4.611 2.979.89.89 0 0 1-.4.365 4.642 4.642 0 0 0 3.837 8.453.89.89 0 0 1 .539-.061 5.942 5.942 0 0 0 1.74.092Z"
      />
    </g>
    <g filter="url(#filter2_iif_5246_190100)" opacity=".2">
      <path
        fill="#050304"
        d="m11.54 13.722.153.197.004-.004-.156-.193Zm.113-.733-.208.136.005.007.203-.143Zm-.238-.23-.14.204.005.003.135-.208Zm-.343-.18-.095.23.003.001.092-.23Zm-.396-.151-.086.233h.003l.083-.233Zm-.396-.159-.108.224.009.004.099-.228Zm-.344-.217-.163.187.005.004.158-.191Zm-.25-.31-.223.11.005.01.217-.12Zm.184-1.216-.181-.17.181.17Zm.819-.383.036.246.212-.031v-.215h-.248Zm0-.759v-.248h-.248v.248h.248Zm.548 0h.248v-.248h-.248v.248Zm0 .74h-.248v.237l.237.01.011-.248Zm.541.072-.057.242.057-.242Zm.397.112.24.06.054-.217-.21-.076-.084.233Zm-.126.515-.087.233.262.098.066-.272-.24-.059Zm-.396-.118-.067.239.007.001.06-.24Zm-1.208.085-.142-.203-.003.002.145.201Zm-.152.687-.217.122.006.01.21-.132Zm.185.192-.146.201.008.005.138-.206Zm.277.145-.096.23h.004l.092-.23Zm.363.139.09-.232-.004-.002-.086.234Zm.891.462-.164.186.008.006.156-.192Zm.284.35.221-.114-.22.114Zm-.178 1.254.176.176.002-.002-.178-.174Zm-.878.357-.03-.247-.218.027v.22h.248Zm0 .851v.249h.248v-.249h-.248Zm-.548 0h-.248v.249h.248v-.249Zm0-.831h.248v-.242l-.241-.007-.007.249Zm-.753-.1-.075.237.005.002.07-.239Zm-.436-.171-.235-.079-.066.197.183.1.118-.218Zm.165-.495.106-.225-.253-.118-.088.264.236.079Zm.476.171.068-.239-.068.24Zm.687.328c.349 0 .66-.051.865-.21l-.304-.393c-.068.052-.232.106-.561.106v.497Zm.869-.214a.76.76 0 0 0 .297-.609h-.497a.266.266 0 0 1-.112.223l.312.386Zm.297-.609a.786.786 0 0 0-.138-.46l-.406.286c.028.04.047.094.047.174h.497Zm-.133-.452a1.043 1.043 0 0 0-.31-.304l-.271.416a.55.55 0 0 1 .165.159l.416-.271Zm-.306-.301a2.037 2.037 0 0 0-.39-.204l-.185.461c.118.048.216.1.295.153l.28-.41Zm-.388-.203a8.569 8.569 0 0 0-.408-.156l-.166.468c.132.047.26.096.384.147l.19-.459Zm-.406-.155a7.202 7.202 0 0 1-.383-.153l-.197.455c.136.06.273.114.41.164l.17-.466Zm-.373-.15a1.438 1.438 0 0 1-.294-.185l-.316.383c.118.097.25.18.394.25l.215-.447Zm-.289-.18a.896.896 0 0 1-.197-.244l-.434.24c.08.145.182.27.305.378l.326-.375Zm-.192-.235a.752.752 0 0 1-.066-.338h-.496c0 .204.035.394.118.56l.444-.222Zm-.066-.338c0-.26.075-.451.21-.596l-.362-.34c-.235.252-.344.571-.344.936h.496Zm.21-.596c.141-.15.357-.26.674-.307l-.072-.491c-.396.058-.726.204-.964.459l.363.339Zm.886-.553v-.759h-.496v.76h.496Zm-.248-.51h.548v-.497h-.548v.496Zm.3-.249v.74h.496v-.74h-.496Zm.237.988c.18.008.345.03.495.066l.115-.484a3.172 3.172 0 0 0-.588-.079l-.022.497Zm.495.066c.163.038.285.073.369.104l.17-.467a3.97 3.97 0 0 0-.424-.12l-.115.483Zm.212-.188-.125.515.482.117.126-.515-.483-.117Zm.203.34a3.96 3.96 0 0 0-.423-.126l-.12.481c.153.039.275.076.369.11l.174-.464Zm-.417-.125a2.504 2.504 0 0 0-.66-.075v.497c.224 0 .398.02.527.057l.133-.479Zm-.66-.075c-.292 0-.554.055-.756.197l.284.407c.087-.061.235-.107.472-.107v-.497Zm-.76.199a.745.745 0 0 0-.314.63h.497c0-.11.037-.176.108-.227l-.29-.403Zm-.314.63c0 .134.026.264.091.38l.433-.244a.275.275 0 0 1-.027-.135h-.497Zm.097.39c.064.102.15.188.25.26l.291-.402a.443.443 0 0 1-.12-.122l-.42.264Zm.258.266c.095.063.202.12.32.168l.19-.458a1.387 1.387 0 0 1-.235-.123l-.275.413Zm.323.17c.112.044.236.091.37.14l.17-.466c-.13-.047-.248-.093-.356-.136l-.184.461Zm.366.14c.167.064.325.13.475.198l.206-.452a8.886 8.886 0 0 0-.503-.21l-.178.463Zm.475.198c.134.061.247.134.341.218l.33-.372a1.871 1.871 0 0 0-.465-.298l-.207.452Zm.349.224a.846.846 0 0 1 .22.272l.441-.228a1.34 1.34 0 0 0-.348-.429l-.313.385Zm.22.272a.825.825 0 0 1 .078.38h.496c0-.222-.04-.429-.133-.608l-.441.228Zm.078.38c0 .26-.076.447-.213.587l.355.347c.241-.248.354-.566.354-.933h-.496Zm-.211.585c-.135.135-.366.24-.733.285l.06.493c.425-.052.78-.184 1.024-.427l-.351-.351Zm-.951.532v.851h.496v-.851h-.496Zm.248.603h-.548v.497h.548v-.497Zm-.3.248v-.831h-.496v.831h.496Zm-.241-1.08a2.792 2.792 0 0 1-.69-.089l-.14.477c.222.065.496.1.816.109l.014-.497Zm-.684-.087a2.398 2.398 0 0 1-.393-.153l-.237.436c.117.064.28.127.479.19l.15-.473Zm-.276.143.165-.495-.471-.157-.165.495.471.157Zm-.176-.348c.147.068.319.13.513.185l.136-.477a2.978 2.978 0 0 1-.438-.158l-.21.45Zm.513.185c.214.061.467.089.755.089v-.497c-.26 0-.463-.025-.619-.07l-.136.478Z"
      />
    </g>
    <g filter="url(#filter3_iif_5246_190100)" opacity=".2">
      <path
        fill="#050304"
        d="m9.438 41.402-.195-.07.195.07Zm.181-.313-.152-.14.152.14Zm.28-.198-.079-.19.079.19Zm.691 0 .08-.19-.08.19Zm.275.198-.156.136.007.006.149-.142Zm.186.313-.194.068.194-.068Zm0 .867-.194-.069.194.069Zm-.186.318-.152-.14.152.14Zm-.275.192-.079-.19.08.19Zm-.691 0 .079-.19-.08.19Zm-.28-.192-.155.136.006.007.149-.143Zm-.181-.318.195-.069-.195.069Zm1.136-.895-.17.116v.002l.17-.118Zm-.659 0 .17.119.001-.003-.17-.116Zm0 .928-.17.115.001.003.17-.118Zm.659 0 .17.118v-.003l-.17-.115Zm1.279 1.048.194.069-.194-.07Zm.18-.313-.151-.14.152.14Zm.972-.197-.079.19.08-.19Zm.275.197-.156.136.006.007.15-.143Zm.186.313.195-.069-.195.069Zm0 .867.195.069-.195-.069Zm-.186.318-.153-.14v.001l.153.14Zm-.275.192-.079-.19.08.19Zm-.971-.192-.156.136.007.007.149-.143Zm-.181-.318.194-.069-.194.069Zm1.136-.895-.171.116.002.003.169-.119Zm-.659 0 .17.119.001-.003-.17-.116Zm0 .928-.17.116.001.002.17-.118Zm.659 0 .169.118.002-.002-.171-.116Zm-.214-3.342.18.101.173-.308h-.353v.207Zm-2.146 3.803v.206h.12l.06-.105-.18-.101Zm-.5 0-.18-.102-.173.308h.353v-.206Zm2.146-3.803V40.7h-.12l-.06.105.18.102Zm-2.697.927c0-.147.02-.267.055-.365l-.39-.137c-.053.151-.077.32-.077.502h.412Zm.055-.365a.697.697 0 0 1 .138-.242l-.304-.278a1.11 1.11 0 0 0-.224.383l.39.137Zm.138-.242a.576.576 0 0 1 .207-.146L9.82 40.7a.989.989 0 0 0-.353.25l.304.278Zm.207-.146a.69.69 0 0 1 .267-.05v-.413c-.15 0-.292.026-.425.081l.158.382Zm.267-.05c.1 0 .187.017.267.05l.157-.382a1.1 1.1 0 0 0-.424-.081v.413Zm.267.05a.527.527 0 0 1 .197.143l.311-.272a.94.94 0 0 0-.35-.253l-.159.382Zm.204.15c.057.06.105.138.14.238l.39-.137a1.067 1.067 0 0 0-.232-.387l-.298.285Zm.14.238c.035.098.055.218.055.365h.413c0-.182-.025-.35-.078-.502l-.39.137Zm.055.365c0 .147-.02.267-.054.365l.39.137c.052-.15.077-.32.077-.502h-.413Zm-.054.365a.71.71 0 0 1-.144.248l.304.279c.101-.11.177-.242.23-.39l-.39-.137Zm-.145.248a.554.554 0 0 1-.2.14l.157.382a.967.967 0 0 0 .348-.244l-.305-.278Zm-.2.14a.69.69 0 0 1-.267.05v.413c.149 0 .291-.026.424-.081l-.158-.382Zm-.267.05a.69.69 0 0 1-.267-.05l-.158.382c.133.055.275.081.425.081v-.412Zm-.267-.05a.609.609 0 0 1-.21-.144l-.298.286c.1.104.217.185.35.24l.158-.382Zm-.204-.137a.76.76 0 0 1-.141-.251l-.39.137c.052.146.125.276.22.386l.311-.272Zm-.141-.251a1.097 1.097 0 0 1-.055-.365h-.412c0 .183.024.351.077.502l.39-.137Zm1.263-.365c0-.22-.043-.422-.153-.58l-.338.237c.043.063.078.169.078.343h.413Zm-.151-.577a.58.58 0 0 0-.5-.26v.412c.077 0 .122.026.158.08l.342-.232Zm-.5-.26a.58.58 0 0 0-.5.26l.341.232c.037-.054.081-.08.159-.08v-.412Zm-.499.258c-.11.157-.152.358-.152.58h.413c0-.175.034-.281.078-.343l-.339-.237Zm-.152.58c0 .22.042.422.15.581l.342-.231c-.045-.067-.08-.177-.08-.35h-.412Zm.152.584c.119.17.294.253.499.253v-.413c-.08 0-.125-.026-.16-.077l-.339.237Zm.499.253c.205 0 .38-.084.498-.253l-.338-.237c-.035.05-.08.077-.16.077v.413Zm.5-.256c.108-.16.15-.36.15-.582h-.412c0 .174-.034.284-.08.35l.342.232Zm1.248 1.366c0-.146.02-.267.054-.364l-.389-.138c-.053.151-.078.32-.078.502h.413Zm.054-.364a.697.697 0 0 1 .14-.243l-.306-.278a1.109 1.109 0 0 0-.223.383l.39.138Zm.139-.242a.577.577 0 0 1 .207-.147l-.158-.381a.988.988 0 0 0-.353.249l.304.278Zm.207-.147a.69.69 0 0 1 .266-.05v-.413c-.149 0-.291.027-.424.082l.158.381Zm.266-.05c.1 0 .188.018.267.05l.158-.381a1.102 1.102 0 0 0-.425-.082v.413Zm.267.05a.528.528 0 0 1 .198.143l.31-.272a.938.938 0 0 0-.35-.252l-.158.381Zm.204.15c.058.06.106.138.141.239l.39-.138a1.063 1.063 0 0 0-.232-.387l-.299.286Zm.141.239c.035.097.055.218.055.364h.412c0-.182-.024-.35-.077-.502l-.39.138Zm.055.364c0 .147-.02.268-.055.365l.39.138c.053-.151.077-.32.077-.503h-.412Zm-.055.365a.71.71 0 0 1-.144.248l.305.279a1.12 1.12 0 0 0 .229-.39l-.39-.137Zm-.144.248a.555.555 0 0 1-.2.14l.157.382a.967.967 0 0 0 .348-.243l-.305-.279Zm-.2.14a.69.69 0 0 1-.268.05V45c.15 0 .292-.027.425-.082l-.158-.381Zm-.268.05a.69.69 0 0 1-.266-.05l-.158.382c.133.055.275.082.424.082v-.413Zm-.266-.05a.61.61 0 0 1-.21-.143l-.298.285c.1.105.217.185.35.24l.158-.381Zm-.204-.137a.759.759 0 0 1-.142-.25l-.389.137c.052.146.124.275.22.385l.311-.272Zm-.142-.25a1.099 1.099 0 0 1-.054-.366h-.413c0 .183.025.352.078.503l.39-.138Zm1.263-.366c0-.22-.042-.422-.152-.579l-.338.237c.043.062.078.168.078.342h.412Zm-.15-.576a.58.58 0 0 0-.5-.261v.413c.077 0 .121.025.158.08l.342-.232Zm-.5-.261a.58.58 0 0 0-.5.26l.341.232c.037-.054.08-.08.158-.08v-.412Zm-.499.258c-.11.157-.152.359-.152.58h.412c0-.175.035-.281.078-.343l-.338-.237Zm-.152.58c0 .22.042.422.15.582l.342-.232c-.045-.067-.08-.177-.08-.35h-.412Zm.152.584a.584.584 0 0 0 .498.253v-.413c-.08 0-.124-.026-.16-.076l-.338.236Zm.498.253c.205 0 .38-.084.499-.253l-.338-.236c-.036.05-.08.076-.16.076v.413Zm.5-.255c.109-.16.151-.361.151-.583h-.412c0 .174-.035.284-.08.351l.342.232Zm-.564-3.56-2.146 3.803.36.203 2.145-3.803-.36-.203Zm-1.966 3.699h-.5v.412h.5v-.413Zm-.32.307 2.146-3.803-.36-.203L9.95 44.61l.36.203Zm1.966-3.698h.5v-.413h-.5v.413Z"
      />
    </g>
    <g filter="url(#filter4_f_5246_190100)">
      <path
        fill="#C9EAFF"
        d="M50.038 50.926c.732 0 1.434-.129 2.085-.365a.915.915 0 0 1 .907.174 4.748 4.748 0 0 0 7.486-5.438.896.896 0 0 1-.07-.37v-.108a4.748 4.748 0 0 0-5.847-4.62.9.9 0 0 1-.766-.167 6.082 6.082 0 0 0-3.795-1.321 6.1 6.1 0 0 0-5.01 2.615.885.885 0 0 1-.434.326 4.774 4.774 0 0 0 3.121 9.021.886.886 0 0 1 .542-.01 6.106 6.106 0 0 0 1.781.263Z"
      />
    </g>
    <g filter="url(#filter5_f_5246_190100)">
      <ellipse cx="31.997" cy="61.074" fill="#C2DEE4" rx="23.515" ry="1.011" />
    </g>
    <mask
      id="mask0_5246_190100"
      width="42"
      height="42"
      x="11"
      y="9"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <circle cx="31.969" cy="29.924" r="20.924" fill="#fff" />
    </mask>
    <g mask="url(#mask0_5246_190100)">
      <circle cx="31.969" cy="29.924" r="20.924" fill="#D9D9D9" />
      <circle
        cx="31.969"
        cy="29.924"
        r="20.924"
        fill="url(#paint0_radial_5246_190100)"
      />
      <circle
        cx="31.969"
        cy="29.924"
        r="20.924"
        fill="url(#paint1_linear_5246_190100)"
      />
      <g filter="url(#filter6_f_5246_190100)">
        <path
          fill="url(#paint2_linear_5246_190100)"
          d="M43.682 45.32c5.77-4.442 7.015-8.864 7.89-15.05-1.854 7.309-5.171 10.678-9.935 14.099-5.49 3.943-10.252 4.5-18.309 3.733 7.062 1.826 14.274 1.897 20.354-2.782Z"
        />
      </g>
    </g>
    <g filter="url(#filter7_ii_5246_190100)">
      <path
        stroke="#000"
        stroke-linecap="round"
        stroke-width="2.242"
        d="m25.004 40.675 15.042-.215"
      />
    </g>
    <g filter="url(#filter8_iif_5246_190100)" opacity=".2">
      <path
        stroke="#050304"
        stroke-linecap="round"
        stroke-width=".497"
        d="M51.785 42.805c.643 0 1.136.123 1.48.37.347.242.52.605.52 1.089 0 .264-.047.49-.144.68a1.16 1.16 0 0 1-.41.456 1.874 1.874 0 0 1-.647.25 4.29 4.29 0 0 1-.865.08h-.508l.035.787h1.382l-1.38-.05-.037.96h-.64v-4.51c.18-.044.38-.073.6-.086.225-.018.43-.026.614-.026Zm.053.56c-.273 0-.482.008-.627.02v1.797h.482c.22 0 .418-.014.594-.04.176-.03.324-.08.442-.145a.733.733 0 0 0 .284-.284.931.931 0 0 0 .1-.456.82.82 0 0 0-.106-.435.714.714 0 0 0-.278-.271 1.125 1.125 0 0 0-.402-.145 2.892 2.892 0 0 0-.489-.04Z"
      />
    </g>
    <g filter="url(#filter9_d_5246_190100)">
      <ellipse
        cx="41.974"
        cy="23.436"
        fill="url(#paint3_radial_5246_190100)"
        rx="7.804"
        ry="8.266"
        transform="rotate(20 41.974 23.436)"
      />
    </g>
    <ellipse
      cx="46.513"
      cy="27.888"
      fill="#fff"
      rx=".754"
      ry="1.914"
      transform="rotate(44.325 46.513 27.888)"
    />
    <ellipse
      cx="42.976"
      cy="30.117"
      fill="#fff"
      rx=".406"
      ry="1.031"
      transform="rotate(77.674 42.976 30.117)"
    />
    <g filter="url(#filter10_d_5246_190100)">
      <ellipse
        cx="21.651"
        cy="23.442"
        fill="url(#paint4_radial_5246_190100)"
        rx="7.804"
        ry="8.266"
        transform="rotate(-20 21.65 23.442)"
      />
    </g>
    <ellipse
      cx="27.994"
      cy="23.942"
      fill="#fff"
      rx=".754"
      ry="1.914"
      transform="rotate(4.326 27.994 23.942)"
    />
    <ellipse
      cx="26.713"
      cy="27.916"
      fill="#fff"
      rx=".406"
      ry="1.031"
      transform="rotate(37.674 26.713 27.916)"
    />
    <circle cx="41.484" cy="24.197" r="3.806" fill="#171A1C" />
    <circle cx="21.498" cy="24.197" r="3.806" fill="#171A1C" />
    <defs>
      <filter
        id="filter0_f_5246_190100"
        width="25.957"
        height="17.773"
        x="1.102"
        y="33.711"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190100"
          stdDeviation=".16"
        />
      </filter>
      <filter
        id="filter1_f_5246_190100"
        width="22.002"
        height="15.262"
        x=".76"
        y="4.31"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190100"
          stdDeviation=".751"
        />
      </filter>
      <filter
        id="filter2_iif_5246_190100"
        width="6.679"
        height="8.364"
        x="8.24"
        y="8.123"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="2.521" dy="1.26" />
        <feGaussianBlur stdDeviation="1.26" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190100" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-1.26" dy="-1.26" />
        <feGaussianBlur stdDeviation="1.26" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190100"
          result="effect2_innerShadow_5246_190100"
        />
        <feGaussianBlur
          result="effect3_foregroundBlur_5246_190100"
          stdDeviation=".245"
        />
      </filter>
      <filter
        id="filter3_iif_5246_190100"
        width="7.303"
        height="6.064"
        x="8.324"
        y="39.781"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="2.095" dy="1.048" />
        <feGaussianBlur stdDeviation="1.048" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190100" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-1.048" dy="-1.048" />
        <feGaussianBlur stdDeviation="1.048" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190100"
          result="effect2_innerShadow_5246_190100"
        />
        <feGaussianBlur
          result="effect3_foregroundBlur_5246_190100"
          stdDeviation=".204"
        />
      </filter>
      <filter
        id="filter4_f_5246_190100"
        width="22.489"
        height="16.192"
        x="39.904"
        y="37.209"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190100"
          stdDeviation=".751"
        />
      </filter>
      <filter
        id="filter5_f_5246_190100"
        width="50.463"
        height="5.457"
        x="6.766"
        y="58.346"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190100"
          stdDeviation=".858"
        />
      </filter>
      <filter
        id="filter6_f_5246_190100"
        width="32.536"
        height="23.276"
        x="21.182"
        y="28.128"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190100"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter7_ii_5246_190100"
        width="18.571"
        height="3.319"
        x="23.454"
        y="38.907"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx=".858" dy=".429" />
        <feGaussianBlur stdDeviation=".429" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190100" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.429" dy="-.429" />
        <feGaussianBlur stdDeviation=".429" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190100"
          result="effect2_innerShadow_5246_190100"
        />
      </filter>
      <filter
        id="filter8_iif_5246_190100"
        width="7.494"
        height="7.638"
        x="49.062"
        y="41.294"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="2.521" dy="1.26" />
        <feGaussianBlur stdDeviation="1.26" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190100" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-1.26" dy="-1.26" />
        <feGaussianBlur stdDeviation="1.26" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190100"
          result="effect2_innerShadow_5246_190100"
        />
        <feGaussianBlur
          result="effect3_foregroundBlur_5246_190100"
          stdDeviation=".245"
        />
      </filter>
      <filter
        id="filter9_d_5246_190100"
        width="29.244"
        height="29.949"
        x="28.854"
        y="10.712"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.970833 0 0 0 0 0.619202 0 0 0 0 0.533958 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190100"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190100"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_d_5246_190100"
        width="29.244"
        height="29.949"
        x="8.532"
        y="10.72"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.972549 0 0 0 0 0.619608 0 0 0 0 0.533333 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190100"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190100"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_5246_190100"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(22.56203 21.52868 -20.13218 21.0985 24.9 24.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEFFCF" />
        <stop offset=".418" stop-color="#FFCA42" />
        <stop offset=".736" stop-color="#FFCF53" />
        <stop offset="1" stop-color="#FF8163" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_5246_190100"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -3.961 57.142) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_5246_190100"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -14.129 34.01) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_5246_190100"
        x1="22.02"
        x2="34.953"
        y1="11.078"
        y2="29.377"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#FEFFCF" />
        <stop offset=".353" stop-color="#FEFFCF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5246_190100"
        x1="43.408"
        x2="36.15"
        y1="45.394"
        y2="38.237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FA552D" />
        <stop offset="1" stop-color="#FA552D" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
